import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FixedFeeTermDetailsLoadingDesktop } from './desktop';
import { FixedFeeTermDetailsLoadingMobile } from './mobile';

export const FixedFeeTermDetailsLoading: React.FC = () => {
  return useBreakpointValue({
    base: <FixedFeeTermDetailsLoadingMobile />,
    sm: <FixedFeeTermDetailsLoadingMobile />,
    lg: <FixedFeeTermDetailsLoadingDesktop />,
  });
};
